<template>
  <div class="animated fadeIn">
    <b-card>

      <!-- HEADER -->
      <template #header>
     
            <b-col md="11">
                <strong  >Vehicle Movement Today</strong>
            </b-col>

            <b-col md="1">
                <b-button class="ml-auto" size="sm" variant="secondary" @click="goback()"> Back
              </b-button>
            </b-col>
            
      </template>
      <div id="listloader" v-if="loader">
          <div class="listloader"></div>
        </div>

        <div
    class="mt-3"
    v-if="todayPlannedVehicle.data.length"
>
        <div class="table-responsive">


        
    <strong>Today's Planned Vehicles</strong>

    <table class="custom-table mt-2">

        <thead>

            <tr>

                <th>Vehicle Type</th>

                <th
                    v-for="hub in todayPlannedVehicle.hubs"
                    :key="hub"
                >
                    {{ hub }}
                </th>

            </tr>

        </thead>

        <tbody>

            <tr>

                <td><b>Regular</b></td>

                <td
                    v-for="hub in todayPlannedVehicle.hubs"
                    :key="'r'+hub"
                >
                    {{ todayPlannedVehicle.data[0][hub].regular }}
                </td>

            </tr>

            <tr>

                <td><b>Adhoc</b></td>

                <td
                    v-for="hub in todayPlannedVehicle.hubs"
                    :key="'a'+hub"
                >
                    {{ todayPlannedVehicle.data[0][hub].adhoc }}
                </td>

            </tr>

        </tbody>

    </table>
</div>
</div>

      <b-row class="mt-3 text-center">
        <b-col 
          v-for="(item, index) in summaryList" 
          :key="index"
        >
          <div
            class="shipment-box"
            :class="{ 
              clickable: Number(item.value) > 0, 
              disabled: Number(item.value) === 0 
            }"
            :style="{ backgroundColor: item.color }"
            @click="Number(item.value) > 0 ? handleCardClick(item) : null"
          >
            <div class="title">{{ item.title }}</div>
            <div class="value">{{ item ? item.value : 0 }} Vehicles</div>
          </div>
        </b-col>
      </b-row>


        <!-- DRILLDOWN SECTION -->
        <div v-if="showHubSection" class="mt-4 hub-section" >

            <div class="d-flex justify-content-between align-items-center mb-2">
                <strong>{{ fisttitle }}</strong>
                <b-button size="sm" variant="secondary" @click="showHubSection = false, showVehicleTable = false">
                Close
                </b-button>
            </div>

            <b-row class="text-center">
                <b-col 
                v-for="(hub, index) in hubList" 
                :key="index" 
                md="3"
                class="mb-2"
                >
                <div class="hub-box clickable"
                @click="handleCardClickvehicledetails(hub)">
                    <div class="hub-title">{{ hub.name }}</div>
                    <div class="hub-value">{{ hub.count }}<br />
                      <span style="font-size:10px;">(No. of Vehicles )</span></div>
                </div>
                </b-col>
            </b-row>

        </div>
        <!-- VEHICLE DETAILS -->
    <div v-if="showVehicleTable" class="mt-3">

      <div class="d-flex justify-content-between mb-2">
        <strong>{{ secondtitle }}</strong>
        <p>Total Count: <span style="color:red; font-weight: 700;">{{ totalcount }} </span></p>
        <b-button size="sm" @click="showVehicleTable = false">Close</b-button>
      </div>
      
        <b-table 
        :items="vehicleTableData"
        :fields="vehicleFields"
        small
        bordered
        >
         <template slot="shipmentcount" slot-scope="row">
             <span 
                class="clickable-link"
                @click="openLoadPopup(row.item.currenthubid, row.item.vehicle_id, row.item.warehouseid, row.item.tripid)"
              >
                {{ row.item.total_parentawb_count }}
              </span>
         </template>
        </b-table>

         <b-col md="12" class=" " v-if="totalcount > 0">
            <paginate 
            v-model="pageNum"
            :page-count="noofpages"
            :page-range="10"
            :margin-pages="2"
            :click-handler="clickCallback"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :container-class="'pagination'"
            :page-class="'page-item'">
            </paginate>
        </b-col>

    </div>
    </b-card>
    <b-modal v-model="showLoadModal" title="Load ID Details" size="lg">

      <b-table 
        :items="loadData"
        :fields="loadFields"
        bordered
        small
      ></b-table>

      <b-col md="12" class=" " v-if="total_count && total_count.length > 0">
          <paginate 
          v-model="pageNum1"
          :page-count="noofpages1"
          :page-range="10"
          :margin-pages="2"
          :click-handler="clickCallback1"
          :prev-text="'Prev'"
          :next-text="'Next'"
          :container-class="'pagination'"
          :page-class="'page-item'">
          </paginate>
        </b-col>
    </b-modal>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Filters from '@/utils/filters'
import Utils from '@/utils'
import { EventBus } from "./event-bus.js";
export default{
    
data(){
    return{
     summaryList: [
      { key:'LH', title: "Line Haul Vehicle(Mid Mile)", value: 0,  color: "#17a2b8" },
      { key:'NationalLH', title: "National Line Haul Vehicle(Mid Mile)", value: 0, color: "#28a745"  },
      { key:'OFD', title: "Direct Delivery Vehicle(Last Mile)", value: 0, color: "#ffc107"  },
      { key:'PickDone', title: "Pickup Vehicle(First Mile)", value: 0,  color: "#dc3545" },
     
    ],
    showHubSection:false,

    hubList: [],
    showVehicleTable: false,
    showLoadModal: false,
    vehicleTableData: [],
    vehicleFields:[],


    loadFields: [
      { key: "load_id", label: "Load ID" },
      { key: "parentawb", label: "AWB" },
      { key: "shipmentstatus", label: "Status" }
    ],

    loadData: [],
    userType:"",
    Usersysuserid:"",
    user_id:"",
    route_id: null,
    selectedstatus:"",
    fisttitle:'',
    secondtitle:'',
    totalcount:0,
    total_count:0,
    pageNum:1,
    pageNum1:1,
    noofpages:'',
    noofpages1:'',
    totalRows: 0,
    selectedhubid:'',
    selectedcurrenthubid:'',
    selectedvehicleid:'',
    selectedwarehouseid :'',
    selectedtripid:'',
    loader:false,
    vehiclecount:{},
    todayPlannedVehicle: {
      hubs: [],
      data: []
    },
    perPage: 10,
    }
},

created(){
  console.log("this.$route.query", this.$route.query)
  var userdata = localStorage.getItem("userData");
  var userInfo = JSON.parse(userdata);
  this.userType=userInfo.user_type;
  this.Usersysuserid=userInfo.sysusermasterid;
  this.user_id = userInfo.sysusermasterid;
  this.route_id = this.$route.params.id || 'normal'
  this.getvehiclemovementtoday();
  this.getTodayPlannedVehicleListing();
},

methods:{
    handleCardClick(item) {
      this.pageNum1 =1 
      this.pageNum =1
        console.log(item )       
     if (item) {
      this.selectedstatus= item.key 
      if(this.selectedstatus == 'OFD'){
        this.fisttitle = 'Direct dispatch vehicle Hubwise Dispatch'
        this.getvehiclewisehubdetails();
      }
      else if(this.selectedstatus == 'PickDone'){
        this.fisttitle = 'Pickup vehicle stockist wise Dispatch'
        this.getvehiclewisehubdetails();
      }
      else if(this.selectedstatus == 'LH'){
        this.fisttitle = 'Line Haul vehicle Hubwise Dispatch'
        // console.log(this.vehiclecount.lh_parentawb);
        this.getlinehaulvehiclewisehubdetails(this.vehiclecount.lh_parentawb)
        
      }
      else {
        this.fisttitle = 'National Line Haul vehicle Hubwise Dispatch'
        //  console.log(this.vehiclecount.nlh_parentawb);
        this.getlinehaulvehiclewisehubdetails(this.vehiclecount.nlh_parentawb)
      }
      
        this.showHubSection = true
        this.showVehicleTable = false
      }
      else {
        this.showHubSection = false
        this.showVehicleTable = false
        this.fisttitle ='';
     }
    },

    handleCardClickvehicledetails(hub) {
       this.pageNum1 =1 
      this.pageNum =1
    if(hub){
      if(this.selectedstatus == 'OFD'){
        this.secondtitle = 'Vehicle waise direct dispatch'
        this.getshipmentcountandvehicledetails(hub.id, this.pageNum);
      }
      else if(this.selectedstatus == 'PickDone'){
        this.secondtitle = 'Vehicle wise pickup'
        this.getshipmentcountandvehicledetails(hub.id, this.pageNum);
      }
      else if(this.selectedstatus == 'LH'){
        this.secondtitle = 'Line Haul vehicle Hubwise Dispatch'
        // console.log(this.vehiclecount.lh_parentawb);
        this.getlinehaulshipmentcountandvehicledetails(this.vehiclecount.lh_parentawb, hub.id, this.pageNum)
        
      }
      else {
        this.secondtitle = 'National Line Haul vehicle Hubwise Dispatch'
        //  console.log(this.vehiclecount.nlh_parentawb);
        this.getlinehaulshipmentcountandvehicledetails(this.vehiclecount.nlh_parentawb, hub.id, this.pageNum)
      }
    this.showVehicleTable = true
    this.selectedhubid= hub.id
   
    }
    else{
      this.secondtitle ="";
      this.showVehicleTable = false
    }
  },

  clickCallback(pageNum){

     if(this.selectedstatus == 'OFD' || this.selectedstatus =='PickDone'){
       this.getshipmentcountandvehicledetails(this.selectedhubid, pageNum)
     }
     else{

      if(this.selectedstatus == 'LH'){

         this.getlinehaulshipmentcountandvehicledetails(this.vehiclecount.lh_parentawb,this.selectedhubid, pageNum)
        
      }
      else {
    
        this.getlinehaulshipmentcountandvehicledetails(this.vehiclecount.nlh_parentawb, this.selectedhubid, pageNum)
      }
      
    }

   
  },

  clickCallback1(pageNum1){
   // alert(this.selectedstatus )
    if(this.selectedstatus == 'OFD' || this.selectedstatus =='PickDone'){
     this.getshipmentdetailsforvehicle( this.selectedcurrenthubid,
      this.selectedvehicleid,
      this.selectedwarehouseid ,
      this.selectedtripid, pageNum1 )
    }
    else{
      
      this.getlinehaulshipmentdetailsforvehicle( this.selectedcurrenthubid,
      this.selectedvehicleid,
      this.selectedwarehouseid ,
      this.selectedtripid, pageNum1 );
    }


    
  },


  getshipmentcountandvehicledetails(hubid, pageNum){
     this.loader= true;
    const obj={
      hub_id: this.$route.query.hub_id || '',
      sysusermasterid: this.Usersysuserid,
      warehouseid: this.$route.query.warehouseid || '',
      edd: this.$route.query.edd || '',
      shipmentjourney: this.$route.query.shipmentjourney || '',
      loadtype: this.$route.query.loadtype || '',
      shipmentstatus: this.selectedstatus,
      currenthubid: hubid,
      page_no: pageNum
    }

    this.$http
      .post(`${CONSTANTS.MISREPORT_API_URL}/getshipmentcountandvehicledetails`, obj)
      .then(result => {
        this.loader = false;

        if (result.data.returnmsg === "Successful") {
          // console.log(result.data.returnvalue)
          this.vehicleTableData =result.data.returnvalue
          this.totalcount = result.data.returnvalue[0].totalcount
          this.noofpages = Math.ceil(this.totalcount / this.perPage);
          let extraFields =[];
          let commonFields =[     
             { key: "vehicle_no", label: "Vehicle Number" },
              { key: "vehicle_type", label: "Vehicle Type" },
              { key: "vehicledimensionsweight", label: "Vehicle Dimensional Weight" ,
                formatter: value => value || 'NA',
              },
              { key: "transporter_company_name", label: "Transporter company name",
                formatter: value => value || 'NA',
              }
          ]
          // alert(this.selectedstatus)
          if(this.selectedstatus == 'OFD'){
            extraFields= [
              { key: "hub_title", label: "Dispatch Hub Name" },
              { key: "tripid", label: "Vehicle Trip" ,
                formatter: value => value || 'NA',
              },
              { key: "startdate", label: "Trip Sumbit Date",
                formatter: value => value || 'NA',
              },
              { key: "shipmentcount", label: "Shipment Count",
                formatter: value => value || 0,
              },
              { key: "total_mpscount", label: "Box Count",
                formatter: value => value || 'NA',
              },
              { key: "destinationcity", label: "Destination Cities",
                formatter: value => value || 'NA',
              },
            ]
         
          }
          if(this.selectedstatus == 'PickDone'){
            extraFields= [
              { key: "warehouseid", label: "warehouse Id", 
               formatter: value => value || 'NA', },
            
              { key: "warehousename", label: "Warehouse Name",
                formatter: value => value || 'NA',
              },
              { key: "shipmentcount", label: "Shipment Count",
                formatter: value => value || 0,
              },
              { key: "total_mpscount", label: "Box Count",
                formatter: value => value || 'NA',
              },
              
            ]
            // this.vehicleFields =[...extraFields]
          }

           this.vehicleFields = [...commonFields, ...extraFields]
          
        }else{
          this.vehicleTableData = []
        }

      })
    
  },

  openLoadPopup(currenthubid, vehicleid, warehouseid, tripid) {
    // console.log("Shipment clicked:", row.item)
    this.showLoadModal = true
    this.selectedcurrenthubid = currenthubid;
    this.selectedvehicleid = vehicleid ;
    this.selectedwarehouseid = warehouseid ;
    this.selectedtripid = tripid ;
    if(this.selectedstatus == 'OFD' || this.selectedstatus =='PickDone'){
      this.getshipmentdetailsforvehicle(currenthubid, vehicleid, warehouseid, tripid, this.pageNum1);
    }
    else{
      this.getlinehaulshipmentdetailsforvehicle(currenthubid, vehicleid, warehouseid, tripid, this.pageNum1);
    }
  
  },

  getshipmentdetailsforvehicle(currenthubid, vehicleid, warehouseid, tripid, pageNum1){
    // console.log("this.$route.query.warehouseid", this.$route.query.warehouseid);
     this.loader= true;
    let tempwarehouseid
    if(warehouseid){
      tempwarehouseid = warehouseid.split(",");
    }
   
    const obj ={
      shipmentstatus :this.selectedstatus,
      currenthubid: currenthubid,
      warehouseid: tempwarehouseid || '',
      vehicle_id: vehicleid,
      tripid: tripid || '',
      page_no: pageNum1
    }

     this.$http
      .post(`${CONSTANTS.MISREPORT_API_URL}/getshipmentdetailsforvehicle`, obj)
      .then(result => {
        this.loader = false;

        if (result.data.returnmsg === "Successful") {
          this.loadData = result.data.returnvalue
          this.total_count = result.data.returnvalue[0].total_count
          // this.noofpages1=parseInt(this.total_count)/10;
          // this.noofpages1=Math.ceil( this.noofpages1);
           this.noofpages1 = Math.ceil(this.total_count / this.perPage);
       
        }
        else{
          this.loadData =[]
        }
      })
  }, 
 

  goback(){
    this.$router.back()
  },

  getvehiclemovementtoday() {
    this.loader= true;
    const obj = {
      hub_id: this.$route.query.hub_id || '',
      sysusermasterid: this.Usersysuserid,
      warehouseid: this.$route.query.warehouseid || '',
      edd: this.$route.query.edd || '',
      shipmentjourney: this.$route.query.shipmentjourney || '',
      loadtype: this.$route.query.loadtype || '',
    };

    this.$http
      .post(`${CONSTANTS.MISREPORT_API_URL}/getvehiclemovementtoday`, obj)
      .then(result => {
        this.loader = false;

        if (result.data.returnmsg === "Successful") {
          this.vehiclecount = result.data.returnvalue;

          // Map API response to summaryList keys
          const valueMap = {
            OFD: this.vehiclecount.OFD || 0,
            PickDone: this.vehiclecount.PickDone || 0,
            LH: this.vehiclecount.lh || 0,
            NationalLH: this.vehiclecount.nlh || 0
          };
          // console.log("this.vehiclecount", this.vehiclecount);
          

          this.summaryList.forEach(item => {
            if (valueMap[item.key] !== undefined) {
              item.value = valueMap[item.key];
            }
          });
        } else {
          
              // Map API response to summaryList keys
          const valueMap = {
            OFD: 0,
            PickDone:  0,
            LH: 0,
            NationalLH: 0
          };

          this.summaryList.forEach(item => {
            if (valueMap[item.key] !== undefined) {
              item.value = valueMap[item.key];
            }
          });

          this.summaryList.forEach(item => {
            item.value = 0;
          });
        }
      });
  },

  getvehiclewisehubdetails(){
    this.loader= true;
    const obj = {
      hub_id: this.$route.query.hub_id || '',
      sysusermasterid: this.Usersysuserid,
      warehouseid: this.$route.query.warehouseid || '',
      edd: this.$route.query.edd || '',
      shipmentjourney: this.$route.query.shipmentjourney || '',
      loadtype: this.$route.query.loadtype || '',
      shipmentstatus: this.selectedstatus,
    };

    this.$http
      .post(`${CONSTANTS.MISREPORT_API_URL}/getvehiclewisehubdetails`, obj)
      .then(result => {
        this.loader = false;

        if (result.data.returnmsg === "Successful") {
        
          this.hubList = result.data.returnvalue
            .map(hub => {

              return {
                name: hub.hub_title,
                count: hub.total_count || 0,
                id: hub.currenthubid
              };
            })
        }
        else{
          
        }
      })
  },

    getlinehaulvehiclewisehubdetails(linehauldata){
    this.loader= true;
    const obj = {
      hub_id: this.$route.query.hub_id || '',
      sysusermasterid: this.Usersysuserid,
      warehouseid: this.$route.query.warehouseid || '',
      edd: this.$route.query.edd || '',
      shipmentjourney: this.$route.query.shipmentjourney || '',
      loadtype: this.$route.query.loadtype || '',
      parentawb:  linehauldata.join(','), 
    };

    console.log(obj)
    this.$http
    .post(`${CONSTANTS.MISREPORT_API_URL}/getlinehaulvehiclewisehubdetails`, obj)
    .then(result => {
      this.loader = false;

      if (result.data.returnmsg === "Successful") {
      
        this.hubList = result.data.returnvalue
          .map(hub => {

            return {
              name: hub.hub_title,
              count: hub.total_count || 0,
              id: hub.currenthubid
            };
          })
      }
      else{
        
      }
    })
  },

  getlinehaulshipmentcountandvehicledetails(linehauldata, hubid, pageNum)
  {
     this.loader= true;
    const obj={
      hub_id: this.$route.query.hub_id || '',
      sysusermasterid: this.Usersysuserid,
      warehouseid: this.$route.query.warehouseid || '',
      edd: this.$route.query.edd || '',
      shipmentjourney: this.$route.query.shipmentjourney || '',
      loadtype: this.$route.query.loadtype || '',
      parentawb:  linehauldata.join(','), 
      currenthubid: hubid,
      page_no: pageNum
    }

    this.$http
      .post(`${CONSTANTS.MISREPORT_API_URL}/getlinehaulshipmentcountandvehicledetails`, obj)
      .then(result => {
        this.loader = false;

        if (result.data.returnmsg === "Successful") {
          // console.log(result.data.returnvalue)
          this.vehicleTableData =result.data.returnvalue
          this.totalcount = result.data.returnvalue[0].totalcount
          this.noofpages=parseInt(this.totalcount)/10;
          this.noofpages=Math.ceil( this.noofpages);
          let extraFields =[];
          let commonFields =[     
             { key: "vehicle_no", label: "Vehicle Number" },
              { key: "vehicle_type", label: "Vehicle Type" },
              { key: "vehicledimensionsweight", label: "Vehicle Dimensional Weight" ,
                formatter: value => value || 'NA',
              },
              { key: "transporter_company_name", label: "Transporter company name",
                formatter: value => value || 'NA',
              }
          ]
            extraFields= [
              { key: "hub_title", label: "Dispatch Hub Name" },
              { key: "tripid", label: "Vehicle Trip" ,
                formatter: value => value || 'NA',
              },
              { key: "startdate", label: "Trip Sumbit Date",
                formatter: value => value || 'NA',
              },
              { key: "shipmentcount", label: "Shipment Count",
                formatter: value => value || 0,
              },
              { key: "total_mpscount", label: "Box Count",
                formatter: value => value || 'NA',
              },
              { key: "destinationcity", label: "Destination Cities",
                formatter: value => value || 'NA',
              },
            ]
         



           this.vehicleFields = [...commonFields, ...extraFields]
          
        }else{
          this.vehicleTableData = []
        }

      })
    
  },

  getlinehaulshipmentdetailsforvehicle(currenthubid, vehicleid, warehouseid, tripid, pageNum1){
    // console.log("this.$route.query.warehouseid", this.$route.query.warehouseid);
     this.loader= true;
    let tempwarehouseid
    if(warehouseid){
      tempwarehouseid = warehouseid.split(",");
    }
   
    const obj ={
      shipmentstatus :this.selectedstatus,
      currenthubid: currenthubid,
      warehouseid: tempwarehouseid || '',
      vehicle_id: vehicleid,
      tripid: tripid || '',
      page_no: pageNum1
    }

     this.$http
      .post(`${CONSTANTS.MISREPORT_API_URL}/getlinehaulshipmentdetailsforvehicle`, obj)
      .then(result => {
        this.loader = false;

        if (result.data.returnmsg === "Successful") {
          this.loadData = result.data.returnvalue
          this.total_count = result.data.returnvalue[0].total_count
          this.noofpages1=parseInt(this.total_count)/10;
          this.noofpages1=Math.ceil( this.noofpages1);
       
        }
        else{
          this.loadData =[]
        }
      })
  }, 
    

  getTodayPlannedVehicleListing(){

    this.$http.post(
        `${CONSTANTS.MISREPORT_API_URL}/getTodayPlannedVehicleListing`
    )
    .then(result=>{

        if(result.data.returnmsg=="Successful"){
            this.todayPlannedVehicle=result.data.returnvalue;
            console.log(this.todayPlannedVehicle);
        }
        else{
            this.todayPlannedVehicle={
                hubs:[],
                data:[]
            };
        }
    })
    .catch(err=>{
        console.log(err);
    });

},

}
}
</script>

<style scoped>
.shipment-box {
  background-color: #20a8d8;
  padding: 15px;
  border-radius: 8px;
  border: 1px solid #999;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  height: 100%;
  min-height: 120px; /* optional */
}

.shipment-box .title {
  font-size: 13px;
  font-weight: bold;
  margin-bottom: 5px;
}

.shipment-box .value {
  font-size: 22px;
  font-weight: bold;
  text-align: right;
  padding: 10px;
}
.clickable {
  cursor: pointer;
  transition: 0.2s;
}
.clickable:hover {
  transform: scale(1.02);
}

.hub-section {
  background: #f1f1f1;
  padding: 15px;
  border-radius: 8px;
}

.hub-box {
  background: #d3d3d3;
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #888;
}

.hub-title {
  font-weight: bold;
  font-size: 13px;
}

.hub-value {
  font-size: 18px;
  font-weight: bold;
}
.custom-table{
    min-width:1200px;
    border-collapse:collapse;
    background:#dff0d8;
}

.custom-table th,
.custom-table td {
  border: 1px solid #666;
  padding: 6px;
  text-align: center;
}

.custom-table th {
  background: #d6d6d6;
  font-weight: bold;
}

.clickable-link {
  color: blue;
  cursor: pointer;
  font-weight: bold;
}

.clickable-link:hover {
  text-decoration: underline;
}

.table-responsive{
    overflow-x:auto;
    -webkit-overflow-scrolling:touch;
}
</style>
